const newTheme = {
  primary: process.env.VUE_APP_PRIMARY_COLOR || "#3434dd",
  secondary: process.env.VUE_APP_PRIMARY_COLOR || "#2c2cb4",
  rufous: "#3434dd",
  accent: "#E86413",
  error: "#f44336",
  warning: "#ff9800",
  info: "#03a9f4",
  success: process.env.VUE_APP_PRIMARY_COLOR || "#3434dd",
  anchor: "red",
  white: "#fff",
  blue: "#3434dd",
};

export default newTheme;
